module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("I will tell you what not to "), _c('i', [_vm._v("say")]), _vm._v(", but I will not tell you what not to "), _c('i', [_vm._v("think")]), _vm._v(". Think whatever you like.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Let’s review.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("THOUGHTS are the things on the In side of your head. They are invisible. Your thoughts are yours. No one else’s. No one else wants them. ")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("WORDS are the things that exit your hole to the Out side of your head, where we are. They are a lot like thoughts, except that we can hear them. We don’t want most of those, either. You can keep them.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Here is every word that you should keep to yourself.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15000446","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/intro2.vue
// module id = 69
// module chunks = 0